import { TableBody, TableCell, TableRow } from "@mui/material";
import styles from "./EmptyTable.module.scss";
import React from "react";
import { GlobeSearchIcon } from "../SvgIcons";

interface EmptyTableProps {
  colSpan?: number;
}

const EmptyTable: React.FC<EmptyTableProps> = ({ colSpan = 6 }) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={colSpan} sx={{ padding: 0 }}>
          <div className={styles["no-data"]}>
            <div className={styles["no-data__body"]}>
              <div className={styles["no-data__body__icon"]}>
                <GlobeSearchIcon />
              </div>
              <div className={styles["no-data__body__text"]}>
                Once your data is uploaded and saved, it will be displayed here.
              </div>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default EmptyTable;
